import { parseISO, addDays, isAfter, addHours } from 'date-fns';

interface DateCheckResult {
  hasThreeDays: boolean;
  threeDaysBefore: string | null;
  error?: string;
}
interface TimeCheckResult {
    hasOneHour: boolean;
    oneHourBefore: string | null;
    error?: string;
  }
  

export const checkAndGetThreeDays = (dateInput: string | Date): DateCheckResult => {
  try {
    let targetDate: Date;

    if (typeof dateInput === 'string') {
      targetDate = parseISO(dateInput);
    } else {
      targetDate = dateInput;
    }

    const now = new Date();
    const threeDaysBefore = addDays(targetDate, -3);
    const threeDaysFromNow = addDays(now, 3);
    const hasThreeDays = isAfter(targetDate, threeDaysFromNow);

    return {
      hasThreeDays: hasThreeDays,
      threeDaysBefore: hasThreeDays ? threeDaysBefore.toISOString() : null,
    };
  } catch (error: any) {
    return {
      hasThreeDays: false,
      threeDaysBefore: null,
      error: error.message,
    };
  }
}


  export const checkAndGetOneHour = (dateTimeInput: string | Date): TimeCheckResult =>{
    try {
      let targetDateTime: Date;
  
      if (typeof dateTimeInput === 'string') {
        targetDateTime = parseISO(dateTimeInput);
      } else {
        targetDateTime = dateTimeInput;
      }
  
      const now = new Date();
      const oneHourBefore = addHours(targetDateTime, -1);
      const oneHourFromNow = addHours(now, 1);
      const hasOneHour = isAfter(targetDateTime, oneHourFromNow);
  
      return {
        hasOneHour: hasOneHour,
        oneHourBefore: hasOneHour ? oneHourBefore.toISOString() : null,
      };
    } catch (error: any) {
      return {
        hasOneHour: false,
        oneHourBefore: null,
        error: error.message,
      };
    }
  }